/* -------------------------------------------------------------------------- */
/*                                 Schema Providers                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const provider = new schema.Entity('providers', {}, { idAttribute: 'providerId' });
export const providers = new schema.Array(provider);
